<ps-ui-modal class="country-quota-modal">
  <h2 psUiModalTitle class="text-center mx-5 w-100">Locale Quota</h2>
  <ps-ui-modal-body class="country-quota-modal-body">
    <div class="form-group justify-content-center mb-4">
      <div class="row form-distribution">
        <div class="px-2 d-flex align-items-center justify-content-center">
          <button
            psUiButton
            class="rounded-0 mx-2"
            (click)="distributeQuotaEqually()"
          >
            Distribute Equally
          </button>
          <button
            psUiButton
            [outline]="true"
            class="rounded-0 mx-2"
            (click)="clearDistribution()"
          >
            Clear Distribution
          </button>

          <div
            class="d-flex align-items-center justify-content-center px-2 fw-bold"
          >
            Total Completes:
            <input
              type="number"
              class="form-control border-0 input-btn text-center rounded-0 mx-1"
              [ngModel]="totalCompletes"
              (ngModelChange)="onTotalCompletesChange($event)"
              oninput="if(this.value.length>5){ this.value = this.value.slice(0,5) }"
              psUiInputRestriction="[0-9]"
            />
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="d-flex justify-content-center py-2">
        <ps-ui-table [data]="multiCountrySurveyData">
          <ng-container formArrayName="multiCountryFormData">
            <ng-container psUiTableColumn title="">
              <ng-template psUiTableCellTemplate let-survey>
                <span class="fw-bold me-3">{{ survey.country_name }}</span>
              </ng-template>
            </ng-container>

            <ng-container psUiTableColumn title="">
              <ng-template psUiTableCellTemplate let-survey>
                <div>
                  <span class="p-1 mr-3 fw-bold language-icon">{{
                    survey.language_code | uppercase
                  }}</span>
                </div>
              </ng-template>
            </ng-container>

            <ng-container psUiTableColumn title="COMPLETES">
              <ng-template psUiTableCellTemplate let-survey let-i="index">
                <ng-container [formGroupName]="i">
                  <div class="d-flex align-items-center mx-3">
                    <input
                      type="number"
                      class="form-control border-0 input-btn text-center rounded-0 mx-1"
                      formControlName="completes_required"
                      (keyup)="onCompletesChange($event, i)"
                      psUiInputRestriction="[0-9]"
                    />

                    <input
                      type="number"
                      class="form-control border-0 input-btn text-center rounded-0 mx-1"
                      maxlength="3"
                      formControlName="completes_percentage"
                      (keyup)="onPercentageChange($event, i)"
                      psUiInputRestriction="[0-9]"
                    />
                    <span>%</span>
                  </div>
                </ng-container>
              </ng-template>
            </ng-container>
            <ng-container
              psUiTableColumn
              title="Entrants"
              *ngIf="shouldShowEntrants"
            >
              <ng-template psUiTableCellTemplate let-survey>
                <div class="align-items-center mx-3 entrants">
                  <span class="p-1">{{ survey.estimated_clicks }}</span>
                </div>
              </ng-template>
            </ng-container>
          </ng-container>
        </ps-ui-table>
      </div>
    </form>
    <div class="row justify-content-center">
      <button
        type="button"
        class="btn btn-primary rounded-0 m-2"
        (click)="saveAllocation()"
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-primary rounded-0 m-2"
        (click)="close('cancel')"
      >
        Cancel
      </button>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
